import { render, staticRenderFns } from "./OrgAlertTemplates.vue?vue&type=template&id=60aae3bf"
import script from "./OrgAlertTemplates.vue?vue&type=script&lang=js"
export * from "./OrgAlertTemplates.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports